var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,2C15.432,2,2,15.432,2,32s13.432,30,30,30c16.569,0,30-13.432,30-30S48.568,2,32,2z M32,59.5 C16.836,59.5,4.5,47.164,4.5,32S16.836,4.5,32,4.5c15.165,0,27.5,12.336,27.5,27.5S47.164,59.5,32,59.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m30.75 29c0-6.479-5.271-11.75-11.75-11.75-6.479 0-11.75 5.271-11.75 11.75s5.271 11.75 11.75 11.75c6.479 0 11.75-5.271 11.75-11.75m-11.75 10.25c-5.651 0-10.25-4.598-10.25-10.25s4.598-10.25 10.25-10.25c5.652 0 10.25 4.598 10.25 10.25s-4.598 10.25-10.25 10.25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m19 24c-2.763 0-5 2.237-5 5s2.236 5 5 5c2.758 0 5-2.237 5-5s-2.243-5-5-5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45,17.25c-6.479,0-11.75,5.271-11.75,11.75S38.521,40.75,45,40.75S56.75,35.479,56.75,29S51.479,17.25,45,17.25z  M45,39.25c-5.652,0-10.25-4.598-10.25-10.25S39.348,18.75,45,18.75S55.25,23.348,55.25,29S50.652,39.25,45,39.25z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m45 24c-2.764 0-5 2.237-5 5s2.236 5 5 5c2.758 0 5-2.237 5-5s-2.242-5-5-5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m38.51 12.645c4.17-.748 8.457.4 11.693 3.133.443.387 1.955-1.205 1.414-1.674-3.736-3.154-8.684-4.479-13.492-3.615-.703.134-.193 2.269.385 2.156"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m13.795 15.627c3.238-2.732 7.525-3.881 11.693-3.133.578.113 1.09-2.021.387-2.156-4.811-.863-9.757.463-13.492 3.615-.541.469.969 2.063 1.412 1.674"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m32 40c-4.969 0-9 4.029-9 9s4.031 9 9 9c4.973 0 9-4.029 9-9s-4.027-9-9-9m-6 6c1.197-2.391 3.436-4 5.998-4 2.567 0 4.803 1.607 6.002 4h-12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWow);
export default __webpack_public_path__ + "static/media/wow.6274e55a64aeb8b826648ca9bd083e41.svg";
export { ForwardRef as ReactComponent };